var map = {
	"./asia": 679,
	"./asia.js": 679,
	"./australia": 681,
	"./australia.js": 681,
	"./cricinfo/africa": 580,
	"./cricinfo/africa.js": 580,
	"./cricinfo/australia": 669,
	"./cricinfo/australia.js": 669,
	"./cricinfo/bangladesh": 670,
	"./cricinfo/bangladesh.js": 670,
	"./cricinfo/global": 671,
	"./cricinfo/global.js": 671,
	"./cricinfo/india": 672,
	"./cricinfo/india.js": 672,
	"./cricinfo/newzealand": 673,
	"./cricinfo/newzealand.js": 673,
	"./cricinfo/pakistan": 674,
	"./cricinfo/pakistan.js": 674,
	"./cricinfo/srilanka": 675,
	"./cricinfo/srilanka.js": 675,
	"./cricinfo/taboola": 667,
	"./cricinfo/taboola.js": 667,
	"./cricinfo/unitedkingdom": 676,
	"./cricinfo/unitedkingdom.js": 676,
	"./cricinfo/unitedstates": 677,
	"./cricinfo/unitedstates.js": 677,
	"./en-global": 682,
	"./en-global.js": 682,
	"./india": 683,
	"./india.js": 683,
	"./philippines": 684,
	"./philippines.js": 684,
	"./portuguese/brazil": 685,
	"./portuguese/brazil.js": 685,
	"./southafrica": 687,
	"./southafrica.js": 687,
	"./spanish/argentina": 688,
	"./spanish/argentina.js": 688,
	"./spanish/chile": 689,
	"./spanish/chile.js": 689,
	"./spanish/colombia": 690,
	"./spanish/colombia.js": 690,
	"./spanish/dominicanrepublic": 691,
	"./spanish/dominicanrepublic.js": 691,
	"./spanish/ecuador": 692,
	"./spanish/ecuador.js": 692,
	"./spanish/guatemala": 693,
	"./spanish/guatemala.js": 693,
	"./spanish/mexico": 694,
	"./spanish/mexico.js": 694,
	"./spanish/panama": 695,
	"./spanish/panama.js": 695,
	"./spanish/peru": 696,
	"./spanish/peru.js": 696,
	"./spanish/spain": 697,
	"./spanish/spain.js": 697,
	"./spanish/unitedstates": 698,
	"./spanish/unitedstates.js": 698,
	"./spanish/uruguay": 699,
	"./spanish/uruguay.js": 699,
	"./spanish/venezuela": 700,
	"./spanish/venezuela.js": 700,
	"./taboola": 680,
	"./taboola.js": 680,
	"./taboolaDefaults": 668,
	"./taboolaDefaults.js": 668,
	"./unitedkingdom": 701,
	"./unitedkingdom.js": 701,
	"./unitedstates": 702,
	"./unitedstates.js": 702
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 678;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config ^\.\/.*$
// module id = 678
// module chunks = 0